var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcmIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97493 18.3334H12.9749C17.1416 18.3334 18.8083 16.6667 18.8083 12.5V7.50002C18.8083 3.33335 17.1416 1.66669 12.9749 1.66669H7.97493C3.80827 1.66669 2.1416 3.33335 2.1416 7.50002V12.5C2.1416 16.6667 3.80827 18.3334 7.97493 18.3334Z",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1416 10.5833L7.1416 10.5667C7.7666 10.5667 8.4666 11.0417 8.69994 11.625L9.64993 14.025C9.8666 14.5667 10.2083 14.5667 10.4249 14.025L12.3333 9.18334C12.5166 8.71668 12.8583 8.70001 13.0916 9.14168L13.9583 10.7833C14.2166 11.275 14.8833 11.675 15.4333 11.675H18.8166",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcmIcon);
export default __webpack_public_path__ + "static/media/ccm_icon.2767d5849268b8b7869035ce390f67af.svg";
export { ForwardRef as ReactComponent };